export default defineAppConfig({
    nuxtIcon: {},
  })